import { jsx as _jsx } from "react/jsx-runtime";
const PageSectionTitle = ({ title }) => {
    return (_jsx("div", { style: { textAlign: 'center', width: '100%' }, children: _jsx("h4", { className: "subtitle", children: title }) }));
};
export default PageSectionTitle;
